export const WIFI_PROVIDER_ENDPOINT =
  "https://starlink.southwestwifi.com/starlinkrouter/sandbox-client";
export const WIFI_USERS_UNSANDBOX_DEVICE_ENDPOINT =
  "/api/inflight-portal/v1/inflight-portal/wifi-users";
